(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-program-page"] && !Shopify.designMode) return;
  try {
    
  function focusPartnerInquiryResult() {
    const result = document.querySelector('[data-partner-result]');
    if (!result) return;
    requestAnimationFrame(() => {
      result.focus({ preventScroll: true });
      result.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusPartnerInquiryResult, { once: true });
  } else {
    focusPartnerInquiryResult();
  }
  document.addEventListener('shopify:section:load', focusPartnerInquiryResult);

  } catch(e) { console.error(e); }
})();
})();
